import type { FaireProductEntity } from "../../entity_types/product";

export const p_pmqce2g3pt: FaireProductEntity = {
  token: "p_pmqce2g3pt",
  type: "product",
  name: "Self-Care Spa Kit | Soul Water Scent | Coastal Vibe | Vegan",
  brandName: "Raven\u2019s Hearth",
  imageUrl:
    "https://cdn.faire.com/fastly/2046f29164c0d5fc3c36c7d737d4dad6b226762358a5c1eb5e10588db1cbcf66.jpeg",
  priceDollars: 16,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/67cc522c1e1184895f46ed8bfbddc18c0cdb342ba74e16c46b530de73abfa18e.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
